/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/feature_flags_info" endpoint
 */
/* eslint-disable camelcase */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdFeatureFlagsInfo } from "./constants";
import type { EngagementAppGroupIdFeatureFlagsInfoResult } from "./types";

export const getEngagementAppGroupIdFeatureFlagsInfo = reactQueryFetcherAdapter(
  engagementAppGroupIdFeatureFlagsInfo,
  (
    signal: AbortSignal,
    appGroupId: string,
    rollout_nst: string
  ): Promise<EngagementAppGroupIdFeatureFlagsInfoResult> => {
    return fetch(`/engagement/${appGroupId}/feature_flags_info`, "GET", { rollout_nst }, { signal });
  }
);
